import React, { useState, useEffect } from 'react';
import './Guests.css';
import DropDownPanel from '../../DropDownPanel/DropDownPanel';
import GuestsCounter from './GuestsCounter/GuestsCounter';

const GuestsMobile = ({ onToggle, isOpen, changeAdults, changChildren, changInfants, enableGuestFilter, clearField, settings }) => {
    const [adults, setAdults] = useState(2);
    const [children, setChildren] = useState(0);
    const [infants, setInfants] = useState(0);
    const [total, setTotal] = useState(2);

    const [maxGuest] = useState(20);


    function adultsHasChanged(val) {
        setAdults(val);
        changeAdults(val);
    }

    function childrenHasChanged(val) {
        setChildren(val);
        changChildren(val);
    }

    function infantsHasChanged(val) {
        setInfants(val);
        changInfants(val);
    }

    useEffect(() => {
        setTotal(parseInt(adults) + parseInt(children) + parseInt(infants));
    }, [adults, children, infants])

    useEffect(() => {
        if (clearField > 0) {
            setAdults(2);
            setChildren(0);
            setInfants(0);
            setTotal(2);
            changeAdults();
            changChildren();
            changInfants();
        }
    }, [clearField])

    if (!enableGuestFilter) {
        changeAdults(null);
        changChildren(null);
        changInfants(null);
    }


    return (
        <>
            {
                enableGuestFilter &&
                <div className={!isOpen ? "" : "tw-border tw-p-5"}>
                   
                   
                        <div onClick={() => onToggle()} className={` ${isOpen ? "" : "tw-border tw-p-5"}`}>
                        WHO
                    </div>

                    {
                        isOpen &&
                            <div title={total + " " + (total === 1 ? 'Guest' : 'Guests')}  >
                                <GuestsCounter name="Adults" min='1' max={maxGuest} initial={adults} upCount={adultsHasChanged} settings={settings} />
                                <GuestsCounter name="children" max={maxGuest} initial={children} upCount={childrenHasChanged} settings={settings} />
                                <GuestsCounter name="Infants" max={maxGuest} initial={infants} upCount={infantsHasChanged} settings={settings} />
                            </div>
                    }
                </div>
            }
        </>
    );
};

 

export default GuestsMobile;
